export async function useFetchTheHeader() {
  const { data: theHeader } = await useFetch<{ [locale: string]: TheHeader }>(
    '/api/the-header',
    {
      baseURL: useRuntimeConfig().public.cms,
      query: {
        populate: 'deep',
        locale: 'all',
      },
      deep: false,
      key: 'dbc-header',
      transform: (response: any) => {
        const data = response.data.map((data: any) => [
          data.locale,
          normalizeTheHeader(data),
        ])
        return Object.fromEntries(data)
      },
    }
  )

  return theHeader
}

function normalizeTheHeader(data: any): TheHeader {
  return {
    locale: data.locale,
    selfServiceLink: data.self_service_link,
    ctaButton: data.cta_button,
    items: data.items,
  }
}
